module.exports = __webpack_public_path__ + "img/bg_coupon_receive.991f7cf1.gif";